<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Exam Attendance </strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-row justify="center" dense>
                <v-col cols="12" sm="12" md="12">
                    
                    <div class="pa-4" v-if="flat_exam_list.length === 0 && !overlay">
                        <v-alert type="info" text outlined>
                            No exams supervisor assigned to you at this time.
                        </v-alert>
                    </div>

                    <v-data-table
                        v-else
                        :headers="table_headers"
                        :items="flat_exam_list"
                        class="elevation-1 mytable ma-3"
                        dense
                        hide-default-footer
                        disable-pagination
                    >

                        <template v-slot:item.srno="{ item }">
                            {{ flat_exam_list.indexOf(item) + 1 }}
                        </template>

                        <template v-slot:item.standard="{ item }">
                            <span class="grey--text text--darken-2">{{ item.standard || '-' }}</span>
                        </template>

                        <template v-slot:item.subject="{ item }">
                            <span class="grey--text text--darken-2">{{ item.subject || '-' }}</span>
                        </template>

                        <template v-slot:item.action="{ item }">
                            <v-btn 
                                rounded 
                                small
                                color="primary" 
                                class="mb-2 mt-2 button"
                                @click="selectRoomForAttendance(item)">
                                Mark Attendance
                            </v-btn>
                        </template>
                    </v-data-table>

                </v-col>
            </v-row>

            <v-dialog v-model="attendance_dialog" persistent scrollable max-width="1800px">
                <v-card class="attendance_card">
                    <v-toolbar color="primary" dark dense flat>
                        <v-icon class="mr-2">mdi-account-check</v-icon>
                        <v-toolbar-title>
                            <strong>Student List - Mark Attendance</strong>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>

                        <v-btn color="green" class="mr-2" @click="downloadFile" :loading="attendanceLoader" :disabled="student_list.length === 0" small>
                            <v-icon left>mdi-export</v-icon>
                            Export Excel
                        </v-btn>
                            <v-btn color="red" @click="exportToPDF" :disabled="student_list.length === 0" small>
                            <v-icon left>mdi-file-pdf-box</v-icon>
                           Export PDF
                        </v-btn>
                        <v-btn icon @click="attendance_dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>

                    <v-card-text class="pt-4" style="max-height: 90vh;">
                        
                        <div v-if="student_list.length === 0" class="pa-4">
                            <v-alert type="info" text outlined class="mb-0 text-center">
                                Seating arrangement not found.
                            </v-alert>
                        </div>

                        <v-data-table 
                            v-else 
                            :headers="student_table_headers" 
                            :items="student_list"
                            class="elevation-1 mytable" 
                            dense 
                            hide-default-footer 
                            disable-pagination>

                            <template v-slot:item.srno="{ item }">
                                {{ student_list.indexOf(item) + 1 }}
                            </template>

                            <template v-slot:header.is_absent>
                                <div class="d-flex flex-column align-center">
                                    <span class="mb-1">Is Absent?</span>
                                    <v-checkbox v-model="selectAllAbsent" hide-details dense color="primary"
                                        class="ma-0 pa-0"></v-checkbox>
                                </div>
                            </template>

                            <template v-slot:item.is_absent="{ item }">
                                <div class="d-flex justify-center align-center">
                                    <v-checkbox v-model="item.is_absent" hide-details dense class="ma-0 pa-0"
                                        @change="markStudentAttendance(item)"></v-checkbox>
                                </div>
                            </template>

                        </v-data-table>
                    </v-card-text>
                    
                    <v-divider></v-divider>

                    <v-card-actions class="px-4 py-3">
                        <v-row justify="center">
                            <v-btn color="grey darken-1" text @click="attendance_dialog = false">
                                Cancel
                            </v-btn>
                            <v-btn color="primary" class="mt-1" elevation="2" @click="saveAttendance" :loading="dialog_loader" :disabled="student_list.length === 0" small>
                                <v-icon left>mdi-content-save</v-icon>
                                Save Attendance
                            </v-btn>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";

export default {
    data: () => ({
        overlay: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        attendance_dialog: false,
        dialog_loader: false,
        attendanceLoader:false,
        student_list: [],
        org_basic_data:[],
        
        table_headers: [
            { text: "Sr No.", value: "srno", sortable: true },
            { text: "Exam Name", value: "exam_name", sortable: true },
            { text: "Exam Date", value: "exam_date", sortable: true },
            { text: "Day", value: "day", sortable: true },
            { text: "Slot No.", value: "slot_no", align: "center", sortable: true },
            { text: "Standard", value: "standard", sortable: true },
            { text: "Subject", value: "subject", sortable: true },
            { text: "Room Allotted", value: "room_number", align: "center", sortable: false },
            { text: "Action", value: "action", align: "center", sortable: false }
        ],

        student_table_headers: [
            { text: "Sr No.", value: "srno", align: "center" },
            { text: "Is Absent?", value: "is_absent", sortable: false, align: "center" },
            { text: "PRN", value: "prn", sortable: true, align: "center" },
            { text: "Roll No", value: "roll_no", sortable: true, align: "center" },
            { text: "Student Name", value: "student_name", sortable: true, align: "center" },
            { text: "Session No", value: "session_no", sortable: true, align: "center" },
            { text: "Exam Date", value: "exam_date", sortable: true, align: "center" },
            { text: "Day", value: "day", sortable: true, align: "center" },
            { text: "Slot No", value: "slot_no", sortable: true, align: "center"},
            { text: "From Time", value: "from_time", sortable: true, align: "center" },
            { text: "To Time", value: "to_time", sortable: true, align: "center" },
            { text: "Subject Code", value: "subject_code", sortable: true, align: "center" },
            { text: "Subject Name", value: "subject_name", sortable: true, align: "center" },
            { text: "Conduct Type", value: "conduct_type", sortable: true, align: "center"},
            { text: "Room No", value: "room_no", sortable: true, align: "center" },
            { text: "Bench No.", value: "bench_number", sortable: true, align: "center" },
            { text: "Bench Side", value: "bench_side", sortable: false, align: "center" },
            { text: "Supervisor", value: "supervisor", sortable: false, align: "center" },
            { text: "Standard", value: "standard", sortable: true},
            { text: "Division", value: "division", sortable: true},
            { text: "Stream", value: "stream", sortable: true}
        ],
        
        flat_exam_list: [], 
    }),

    computed: {
        selectAllAbsent: {
            get() {
                return (
                    this.student_list.length > 0 && 
                    this.student_list.every(student => student.is_absent)
                );
            },
            set(value) {
                this.student_list.forEach(student => {
                    if (student.is_absent !== value) {
                        student.is_absent = value;
                        this.markStudentAttendance(student);
                    }
                });
            }
        }
    },

    mounted() {
        this.onLoad();
    },

    methods: {
        onLoad() {
            this.overlay = true;
            axios
                .post("/SeatingArrangement/getExamPlans")
                .then((res) => {
                    if (res.data.flag === "YES") { 
                        let tempArray = [];
                        res.data.exam_plan_list.forEach(plan => {
                            plan.assigned_rooms.forEach(room => {
                                tempArray.push({
                                    exam_plan_id: plan.exam_plan_id,
                                    exam_name: plan.exam_name,
                                    exam_room_offering_schedule_id: room.exam_room_offering_schedule_id,
                                    room_offering_id: room.room_offering_id,
                                    room_number: room.room_number,
                                    exam_date: room.exam_date,
                                    day: room.day,
                                    slot_no: room.slot_no,
                                    standard: room.standard,
                                    subject: room.subject
                                });
                            });
                        });
                        this.flat_exam_list = tempArray;
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Failed to load exam plans.");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        selectRoomForAttendance(item) {
            this.overlay = true;
            const data = {
                exam_plan_id: item.exam_plan_id,
                room_offering_id: item.room_offering_id,
                exam_room_offering_schedule_id: item.exam_room_offering_schedule_id
            };

            axios.post("/SeatingArrangement/getStudentsForAttendance", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.student_list = res.data.student_list;
                        this.org_basic_data = res.data.org_basic_data;
                        this.attendance_dialog = true; 
                    } else {
                        this.showSnackbar("#b71c1c", "Unable to load students.");
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Error fetching student data.");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        markStudentAttendance(studentItem) {
            window.console.log("Updating Seating ID:", studentItem.seating_id, "to Absent:", studentItem.is_absent);
        },

        saveAttendance() {
            this.dialog_loader = true;
            
            const payload = {
                attendance_data: this.student_list.map(student => ({
                    seating_id: student.seating_id,
                    is_absent: student.is_absent ? 1 : 0
                }))
            };

            axios.post("/SeatingArrangement/saveStudentAttendance", payload)
                .then((res) => {
                    if (res.data.msg === "200") {
                        this.showSnackbar("#4CAF50", "Attendance saved successfully.");
                    } else {
                        this.showSnackbar("#b71c1c", "Failed to save attendance.");
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Error saving attendance data.");
                })
                .finally(() => {
                    this.dialog_loader = false;
                });
        },

        downloadFile() {
            if (!this.student_list || !this.student_list.length) {
                this.showSnackbar("#b71c1c", "No attendance data to export.");
                return;
            }

            this.attendanceLoader = true;
            const excelData = this.student_list.map((item, index) => ({
                "S.No": index + 1,
                "Is Absent?": item.is_absent ? "Yes" : "No",
                "PRN": item.prn || "-",
                "Roll No": item.roll_no || "-",
                "Student Name": item.student_name || "-",
                "Exam Date": item.exam_date || "-",
                "Exam Day": item.day || "-",
                "Slot No": item.slot_no || "-",
                "From Time": item.from_time || "-",
                "To Time": item.to_time || "-",
                "Subject Code": item.subject_code || "-",
                "Subject Name": item.subject_name || "-",
                "Conduct Type": item.conduct_type || "-",
                "Room No": item.room_no || "-",
                "Bench No": item.bench_number || "-",
                "Bench Side": item.bench_side || "-",
                "Supervisor": item.supervisor || "-",
                "Standard": item.standard || "-",
                "Division": item.division || "-",
                "Stream": item.stream || "-"
            }));

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Student Exam Attendance");
            XLSX.writeFile(workbook, "Student_Exam_Attendance_List.xlsx");
            this.attendanceLoader = false;
        },

        exportToPDF() {
            if (!this.student_list || !this.student_list.length) {
                this.showSnackbar("#b71c1c", "No data available to export");
                return;
            }

            const printWindow = window.open("", "_blank");

            let html = `
                <html>
                <head>
                    <title>Student Exam Attendance</title>
                    <style>
                        @page {
                            size: A4 landscape;
                            margin: 8mm;
                        }

                        body {
                            font-family: Arial, sans-serif;
                            font-size: 9px;
                            margin: 0;
                        }

                        h2 {
                            text-align: center;
                            margin: 0 0 10px 0;
                            font-size: 16px;
                        }

                        table {
                            width: 100%;
                            border-collapse: collapse;
                        }

                        th, td {
                            border: 1px solid #000;
                            padding: 4px;
                            text-align: left;
                            vertical-align: middle;
                            font-size: 12px;
                        }

                        th {
                            background: #f2f2f2;
                            font-weight: bold;
                            text-align: center;
                        }

                        tr {
                            page-break-inside: avoid;
                        }
                        
                        div {
                            height:40px;
                            width: 50px;
                        }

                    </style>
                </head>
                <body>
                
                <div style="
                    display:flex;
                    align-items:center;
                    justify-content:space-between;
                    width:100%;
                    box-sizing:border-box;
                    margin-bottom:40px;
                    margin-top:10px;
                ">

                    <img
                        src="${this.org_basic_data.trust_logo || ''}"
                        style="width:80px; height:70px; object-fit:contain; flex-shrink:0;"
                    />

                    <div style="flex:1; text-align:center; min-width:0;">
                        <h2>${this.org_basic_data.trust_name || ''}</h2>
                        <h2>${this.org_basic_data.school_name || ''}</h2>
                        <h2>Student Exam Attendance</h2>
                    </div>

                    <img
                        src="${this.org_basic_data.school_logo || ''}"
                        style="width:80px; height:70px; object-fit:contain; flex-shrink:0;"
                    />

                </div>

                <table>
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Is Absent?</th>
                            <th>PRN</th>
                            <th>Roll No</th>
                            <th>Student Name</th>
                            <th>Exam Date</th>
                            <th>Exam Day</th>
                            <th>Slot No</th>
                            <th>From Time</th>
                            <th>To Time</th>
                            <th>Subject Code</th>
                            <th>Subject Name</th>
                            <th>Conduct Type</th>
                            <th>Room No</th>
                            <th>Bench No</th>
                            <th>Bench Side</th>
                            <th>Supervisor</th>
                            <th>Standard</th>
                            <th>Division</th>
                            <th>Stream</th>
                        </tr>
                    </thead>
                    <tbody>
            `;

            this.student_list.forEach((item, index) => {
                html += `
                    <tr>
                        <td>${index + 1}</td>
                        <td>${item.is_absent ? "Yes" : "No"}</td>
                        <td>${item.prn || ""}</td>
                        <td>${item.roll_no || ""}</td>
                        <td>${item.student_name || ""}</td>
                         <td>${item.exam_date || ""}</td>
                        <td>${item.day || ""}</td>
                        <td>${item.slot_no || ""}</td>
                        <td>${item.from_time || ""}</td>
                        <td>${item.to_time || ""}</td>
                        <td>${item.subject_code || ""}</td>
                        <td>${item.subject_name || ""}</td>
                        <td>${item.conduct_type || ""}</td>
                        <td>${item.room_no || ""}</td>
                        <td>${item.bench_number || ""}</td>
                        <td>${item.bench_side || ""}</td>
                        <td>${item.supervisor || ""}</td>
                        <td>${item.standard || ""}</td>
                        <td>${item.division || ""}</td>
                        <td>${item.stream || ""}</td>
                    </tr>
                `;
            });

            html += `
                    </tbody>
                </table>

                </body>
                </html>
            `;

            printWindow.document.open();
            printWindow.document.write(html);
            printWindow.document.close();

           printWindow.onload = function() {
                const images = printWindow.document.images;
                const imagePromises = [];

                for (let i = 0; i < images.length; i++) {
                    if (!images[i].complete) {
                        imagePromises.push(new Promise(resolve => {
                            images[i].onload = resolve;
                            images[i].onerror = resolve;
                        }));
                    }
                }

                Promise.all(imagePromises).then(function() {
                    printWindow.focus();
                    printWindow.print();
                });
            };
        },


        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        }
    }
};
</script>

<style scoped>
.mytable {
    border-radius: 8px;
    overflow: hidden;
}

.mytable ::v-deep .v-data-table__wrapper {
    border-radius: 8px;
}

.mytable ::v-deep table {
    border-collapse: separate;
    border-spacing: 0;
}

.mytable ::v-deep thead th {
    background: #f5f7fa !important;
    color: #37474f !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    white-space: nowrap;
    height: 44px !important;
    border-bottom: 1px solid #dfe3e8 !important;
    text-align: center !important;
    vertical-align: middle !important;
}

.mytable ::v-deep tbody td {
    font-size: 13px !important;
    padding: 8px 10px !important;
    white-space: nowrap;
    border-bottom: 1px solid #eeeeee !important;
    text-align: center !important;
    vertical-align: middle !important;
}

.mytable ::v-deep tbody tr:hover {
    background: #fafafa !important;
}

.mytable ::v-deep th,
.mytable ::v-deep td {
    text-align: center !important;
    vertical-align: middle !important;
}
</style>